import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IonicModule } from 'ionic-angular'
import { MaterialModule } from './material.module'
import { AlertBar } from './alert/alert-bar/alert-bar.component'
import { ColorCode } from './color_code/color-code/color-code.component'
import { GraphBasic } from './graph/graph-basic/graph-basic.component'
import { GraphGroup } from './graph/graph-group/graph-group.component'
import { GridRow } from './grid/grid-row/grid-row.component'
import { SpreadSheet } from './spread_sheet/spread-sheet/spread-sheet.component'
import { CellRegion } from './spread_sheet/cell-region/cell-region.component'
import { Tabs } from './tab/tabs/tabs.component'
import { TabPulldown } from './tab/tab-pulldown/tab-pulldown.component'
import { Pill } from './tab/pill/pill.component'
import { CheckboxField } from './checkbox/checkbox-field/checkbox-field.component'
import { CheckboxesField } from './checkbox/checkboxes-field/checkboxes-field.component'
import { Tag } from './checkbox/tag/tag.component'
import { Tags } from './checkbox/tags/tags.component'
import { DataTable } from './table/data-table/data-table.component'
import { SingleLineDisplayColumn } from './table/single-line-display-column/single-line-display-column.component'
import { NumberDisplayColumn } from './table/number-display-column/number-display-column.component'
import { SingleLineLinkColumn } from './table/single-line-link-column/single-line-link-column.component'
import { ButtonColumn } from './table/button-column/button-column.component'
import { IconColumn } from './table/icon-column/icon-column.component'
import { TextWithIconColumn } from './table/text-with-icon-column/text-with-icon-column.component'
import { CheckboxColumn } from './table/checkbox-column/checkbox-column.component'
import { RowSelectedColumn } from './table/row-selected-column/row-selected-column.component'
import { CheckflagColumn } from './table/checkflag-column/checkflag-column.component'
import { RadioButtonColumn } from './table/radio-button-column/radio-button-column.component'
import { ColorCodeColumn } from './table/color-code-column/color-code-column.component'
import { InputDatepickerColumn } from './table/input-datepicker-column/input-datepicker-column.component'
import { PulldownColumn } from './table/pulldown-column/pulldown-column.component'
import { SingleTextInputColumn } from './table/single-text-input-column/single-text-input-column.component'
import { NumberInputColumn } from './table/number-input-column/number-input-column.component'
import { MultilineTextInputColumn } from './table/multiline-text-input-column/multiline-text-input-column.component'
import { SelectorInputColumn } from './table/selector-input-column/selector-input-column.component'
import { ActionList } from './table/action-list/action-list.component'
import { FixationTable } from './table/fixation-table/fixation-table.component'
import { EmptyTableData } from './table/empty-table-data/empty-table-data.component'
import { Breadcrumb } from './breadcrumb/breadcrumb/breadcrumb.component'
import { FileUploadField } from './file/file-upload-field/file-upload-field.component'
import { Form } from './form/form/form.component'
import { FormItem } from './form/form-item/form-item.component'
import { ButtonPanel } from './form/button-panel/button-panel.component'
import { Button } from './form/button/button.component'
import { TextWithIconButton } from './form/text-with-icon-button/text-with-icon-button.component'
import { SingleLineInputField } from './form/single-line-input-field/single-line-input-field.component'
import { NumberInputField } from './form/number-input-field/number-input-field.component'
import { SingleLineDisplayField } from './form/single-line-display-field/single-line-display-field.component'
import { NumberDisplayField } from './form/number-display-field/number-display-field.component'
import { Panel } from './form/panel/panel.component'
import { Title } from './form/title/title.component'
import { InputDatepickerField } from './form/input-datepicker-field/input-datepicker-field.component'
import { InputDaterangeField } from './form/input-daterange-field/input-daterange-field.component'
import { SearchInputField } from './form/search-input-field/search-input-field.component'
import { CodeInputSearchField } from './form/code-input-search-field/code-input-search-field.component'
import { HorizontalSeparator } from './form/horizontal-separator/horizontal-separator.component'
import { TextDisplayField } from './form/text-display-field/text-display-field.component'
import { SingleLinkDisplayField } from './form/single-link-display-field/single-link-display-field.component'
import { IconButton } from './form/icon-button/icon-button.component'
import { MultipleSelectorField } from './form/multiple-selector-field/multiple-selector-field.component'
import { SelectorInputField } from './form/selector-input-field/selector-input-field.component'
import { MultipleLineInputField } from './form/multiple-line-input-field/multiple-line-input-field.component'
import { Iframe } from './form/iframe/iframe.component'
import { Footer } from './footer/footer/footer.component'
import { PulldownField } from './pulldown/pulldown-field/pulldown-field.component'
import { RadioButtonField } from './radio_button/radio-button-field/radio-button-field.component'
import { ProgressSpinner } from './loading/progress-spinner/progress-spinner.component'
import { SearchResultNumberField } from './search_condtion/search-result-number-field/search-result-number-field.component'
import { SearchConditionField } from './search_condtion/search-condition-field/search-condition-field.component'
import { SearchResultField } from './search_condtion/search-result-field/search-result-field.component'
import { ListBuilder } from './list_builder/list-builder/list-builder.component'
import { CommonComponentsModule, CoreModule, TimerUtil } from '@ar2/common'

// ** a workaround for https://github.com/ionic-team/ionic/issues/6923
import { Directive, ContentChildren, QueryList, Self } from '@angular/core'
import { Subscription } from 'rxjs'
import { Segment, SegmentButton } from 'ionic-angular'
import { VirtualScrollModule } from 'angular2-virtual-scroll'

const widgets:any[] = [
  AlertBar,
  ColorCode,
  GraphBasic,
  GraphGroup,
  GridRow,
  SpreadSheet,
  CellRegion,
  Tabs,
  TabPulldown,
  Pill,
  CheckboxField,
  CheckboxesField,
  Tag,
  Tags,
  DataTable,
  SingleLineDisplayColumn,
  NumberDisplayColumn,
  SingleLineLinkColumn,
  ButtonColumn,
  IconColumn,
  TextWithIconColumn,
  CheckboxColumn,
  RowSelectedColumn,
  CheckflagColumn,
  RadioButtonColumn,
  ColorCodeColumn,
  InputDatepickerColumn,
  PulldownColumn,
  SingleTextInputColumn,
  NumberInputColumn,
  MultilineTextInputColumn,
  SelectorInputColumn,
  ActionList,
  FixationTable,
  EmptyTableData,
  Breadcrumb,
  FileUploadField,
  Form,
  FormItem,
  ButtonPanel,
  Button,
  TextWithIconButton,
  SingleLineInputField,
  NumberInputField,
  SingleLineDisplayField,
  NumberDisplayField,
  Panel,
  Title,
  InputDatepickerField,
  InputDaterangeField,
  SearchInputField,
  CodeInputSearchField,
  HorizontalSeparator,
  TextDisplayField,
  SingleLinkDisplayField,
  IconButton,
  MultipleSelectorField,
  SelectorInputField,
  MultipleLineInputField,
  Iframe,
  Footer,
  PulldownField,
  RadioButtonField,
  ProgressSpinner,
  SearchResultNumberField,
  SearchConditionField,
  SearchResultField,
  ListBuilder,
]

// TODO: Hotfix for dynamic ion-segment-buttons issue (https://github.com/driftyco/ionic/issues/6923).
@Directive({
    selector: 'ion-segment'
})
export class IonSegmentHotfix {
    private subscriptions: Subscription;

    @ContentChildren(SegmentButton)
    buttons: QueryList<SegmentButton>;

    constructor(@Self() private segment: Segment, private timeUtil: TimerUtil) {
    }

    ngAfterContentInit() {
        this.subscriptions = this.buttons.changes.subscribe(() => this.onChildrenChanged());
    }

    ngOnDestroy() {
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
            this.subscriptions = null;
        }
    }

    private onChildrenChanged() {
        this.timeUtil.timeout(0).subscribe(() => {
            this.segment.ngAfterContentInit();
            this.segment._inputUpdated();
        });
    }
}

/**
 * カスタムウィジェットモジュール
 * @author nabla2.metamodel.generator
 */
@NgModule({
  imports:[
    CommonModule,
    IonicModule,
    MaterialModule,
    CommonComponentsModule,
    CoreModule,
    VirtualScrollModule,
  ],
  declarations: [IonSegmentHotfix, ...widgets],
  entryComponents: widgets,
  exports: [IonSegmentHotfix, ...widgets],
})
export class WidgetModule {}


// WEBPACK FOOTER //
// ./src/widgets/widget.module.ts